import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Flex, Card } from 'pcln-design-system'
import ButtonOption from '@pcln/segmented-control'

const ButtonGroupWrapper = styled(Card)`
  box-shadow: none;
`

const ButtonCategoryGroup = ({ handleChange, filters = [], hideLastPlus }) => {
  return (
    filters.length !== 0 && (
      <ButtonGroupWrapper mt={2} borderColor='primary' className='pclnFilter__buttonGroup'>
        <Flex alignItems='center'>
          {filters.map((buttonInfo, index) => (
            <ButtonOption
              data-test='button-option'
              handleClick={handleChange}
              hidePlus={hideLastPlus && index === filters.length - 1}
              key={buttonInfo.value}
              {...buttonInfo}
            />
          ))}
        </Flex>
      </ButtonGroupWrapper>
    )
  )
}

ButtonCategoryGroup.propTypes = {
  handleChange: PropTypes.func,
  filters: PropTypes.array,
  hideLastPlus: PropTypes.bool,
}

export default ButtonCategoryGroup
